<template>
  <v-app class="bd-app">
    <v-main>
      <Header :key="$route.fullPath" />
      <div class="bd-app-content">
        <router-view></router-view>
      </div>
      <div class="footer-spacer" />
      <Footer />
    </v-main>
  </v-app>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  components: { Header, Footer },
  methods: {
    isLogin() {
      return this.$route.fullPath.includes('/login')
    }
  }
}
</script>

<style lang="scss">
@import './styles/global.scss';

.bd-app {
  min-width: 320px;
  height: 100%;

  .v-application--wrap {
    min-height: 100%;
  }

  .footer-spacer {
    height: 80px;
  }
}
</style>
